module.exports = __webpack_public_path__ + "assets/img/zh-Hant-544ba416.png";